import Flex from "../../../../designComponents/Flex";
import Typography from "../../../../designComponents/Typography";

type Props = {
  amenities: {
    icon: string;
    title: string;
  }[];
};

const AmenitiesViewer = ({ amenities }: Props) => {
  if (amenities?.length === 0) {
    return null;
  }
  return (
    <div>
      {amenities?.map((a) => {
        return (
          <Flex key={a.title} direction="row" gap={"16px"}>
            <img
              src={a.icon}
              alt={a.title}
              style={{ height: "20px", width: "20px" }}
            />
            <Typography>{a.title}</Typography>
          </Flex>
        );
      })}
    </div>
  );
};

export default AmenitiesViewer;
